import { WRRST_FLG, WRRST_FLG_SET } from './seo';

export const META_TAG_SETTING = [
  {
    url: 'DodaFront/*',
    title: '求人情報の検索結果一覧 - 転職ならdoda（デューダ）',
    keywords: '転職	求人	求人情報',
    description:
      '求人・求人情報の検索ならdoda（デューダ）。大手・優良企業を中心に豊富な求人情報から最適な求人を求人検索。',
    settingFlg: WRRST_FLG,
  },
  {
    url: 'engineer/*',
    title:
      'エンジニア転職・IT転職ならdoda（デューダ）エンジニア　-　技術者専門の求人、転職情報が満載のエンジニア転職サイト',
    keywords: 'エンジニア	エンジニア 転職	IT転職	it	転職	技術者	転職情報	求人	求人情報',
    description:
      'エンジニアの転職、IT転職ならdoda（デューダ）。IT業界、モノづくり、メーカー系など豊富な転職・求人情報で希望の転職が見つかります。',
    settingFlg: WRRST_FLG,
  },
  {
    url: 'DodaFront/View/MatchJobList/*',
    title: '希望条件にマッチした求人一覧 | 転職ならdoda（デューダ）',
    keywords: '希望条件にマッチした求人一覧	転職	求人	求人情報',
    description:
      '転職・求人情報ページ。パーソルキャリアが運営する転職サイトのdoda（デューダ）では、大手・優良企業を中心に豊富な求人情報を掲載中。エージェントサービスでは、キャリアアドバイザーが、非公開求人のご紹介など、あなたの転職を成功に導くお手伝いをします。',
    settingFlg: WRRST_FLG,
  },
  {
    url: 'DodaFront/View/Top/*',
    title: '転職ならdoda(デューダ) 求人､転職情報満載の転職サイト',
    keywords:
      '転職,転職情報,転職サイト,求人,求人情報,非公開求人,doda,デューダ,ドーダ,ドゥーダ,duda,でゅーだ',
    description:
      'dodaは業界最大級の支援実績で、転職相談、求人紹介・検索・応募、企業からのスカウト、面接対策のお手伝いまで転職を全面的にサポートする完全無料の転職サイト。大手・優良企業、完全週休二日、未経験者歓迎など求人多数。',
    settingFlg: WRRST_FLG,
  },
  {
    url: 'DodaFront/View/JobSearchTop/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/JobSearchList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/JobSearchDetail/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/FeaturedJobList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/NewJobList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/RelatedJobList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/JobHistoryList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/SeminarList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/SeminarDetail/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/RecommendJobList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/ConditionChange/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/ITJobSearchTop/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/HWJobSearchTop/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/ENJobSearchList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/ENJobSearchDetail/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/JobSearchDetail/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/ITJobSearchTop/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/RelatedJobList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/ITConditionChange/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'engineer/View/HWConditionChange/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/RouteList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/StationList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/CareerRecommendJobList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
  {
    url: 'DodaFront/View/QualificationList/*',
    title: null,
    keywords: null,
    description: null,
    settingFlg: WRRST_FLG_SET,
  },
];
